import { NgModule } from '@angular/core';

import { SharedModule } from '@app/shared';
import { ProjectPermissionComponent } from './project-permission/project-permission.component';
import { ProjectManagementComponent } from './project-management.component';

@NgModule({
    imports: [SharedModule],
    declarations: [
        ProjectPermissionComponent,
        ProjectManagementComponent
    ],
    entryComponents: [ProjectManagementComponent],
    exports: [ProjectManagementComponent]
})
export class ProjectManagementModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/usersRolesManagement/project-management/project-management.module.ts